import { StorageState } from '../../../reducers';

export const technicalWorkingStatesSelector = (state: StorageState) => state.unauthorizedTechnicalWorking.states;
